import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { clsx } from 'clsx';
import { useAtom, useAtomValue } from 'jotai';
import { Button, useParameters } from '@web/utils';
import { cartAtom, isCartOpenAtom } from '@/store/atoms';
import CartItem from '../CartItem/CartItem';

interface CartRouteParameters {
  retailerId: string;
}

const Cart = () => {
  const { retailerId } = useParameters<CartRouteParameters>();
  const cart = useAtomValue(cartAtom);
  const cartItems = cart[retailerId];

  const cartRef = useRef<HTMLDivElement | null>(null);

  const [isCartOpen, setCartOpen] = useAtom(isCartOpenAtom);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoToCheckout = () => {
    navigate(`/${retailerId}/checkout`);
    setCartOpen(false);
  };

  const handleClickOutside = (e: any) => {
    if (cartRef.current && !cartRef.current.contains(e.target as Node)) {
      setCartOpen(false);
    }
  };
  // console.log(cartItems);

  return (
    <div
      className={clsx(
        isCartOpen ? 'block' : 'hidden',
        'fixed w-screen h-screen top-0 left-0 md:left-[auto] mx-auto container',
      )}
      onClick={handleClickOutside}
    >
      <div
        ref={cartRef}
        className={clsx(
          isCartOpen ? 'block' : 'hidden',
          'absolute w-full max-w-95-percent md:max-w-[34.5rem] top-[70px] right-2-0 md:right-6-0 z-99 cart-container rounded-base',
          'border border-secondary-grey bg-primary-white',
        )}
      >
        <div className="custom-scrollbar max-h-[80rem] md:max-h-[60rem] overflow-auto border-b border-secondary-grey p-2-0">
          {cartItems?.length > 0 &&
            cartItems.map((delivery) =>
              delivery.items.map((article) => (
                <CartItem key={article.catalogueID} article={article} />
              )),
            )}
          {cartItems?.length === 0 && (
            <p className="text-body1 leading-1-0">{t('checkout.empty_cart')}</p>
          )}
        </div>
        <Button
          disabled={cartItems?.length === 0}
          variant="secondary"
          className="ml-auto block m-2-0"
          onClick={handleGoToCheckout}
        >
          {t('checkout.go_to_checkout')}
        </Button>
      </div>
    </div>
  );
};

export default Cart;
